import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Alert,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleIcon from "@mui/icons-material/People";

// ✅ كل القياسات + كل الأنواع حسب ملف الأسعار
// الأنواع: أل بدون خشب، أل مع الخشب، كاس تك مع فايبر، كاس دبل مع فايبر، خشب فقط
const PRICE_GROUPS = [
  {
    sizes: ["20*20", "30*30", "30*40"],
    prices: { aluNoWood: 11000, aluWithWood: 13000, kasTekFiber: 15000, kasDoubleFiber: 20000, woodOnly: 3000 }
  },
  {
    sizes: ["40*40", "40*50", "50*50"],
    prices: { aluNoWood: 14000, aluWithWood: 18000, kasTekFiber: 20000, kasDoubleFiber: 28000, woodOnly: 4000 }
  },
  {
    sizes: ["50*60", "60*60", "50*70"],
    prices: { aluNoWood: 16500, aluWithWood: 20500, kasTekFiber: 25000, kasDoubleFiber: 33000, woodOnly: 4000 }
  },
  {
    sizes: ["70*70", "60*90", "60*80"],
    prices: { aluNoWood: 19000, aluWithWood: 24000, kasTekFiber: 30000, kasDoubleFiber: 40000, woodOnly: 5000 }
  },
  {
    sizes: ["80*80", "100*80", "70*90"],
    prices: { aluNoWood: 22000, aluWithWood: 27000, kasTekFiber: 40000, kasDoubleFiber: 52000, woodOnly: 5000 }
  },
  {
    sizes: ["100*100", "60*120", "100*90"],
    prices: { aluNoWood: 25000, aluWithWood: 32000, kasTekFiber: 45000, kasDoubleFiber: 60000, woodOnly: 7000 }
  },
  {
    sizes: ["80*120", "80*130","130*70"],
    prices: { aluNoWood: 28000, aluWithWood: 36000, kasTekFiber: 50000, kasDoubleFiber: 63000, woodOnly: 8000 }
  },
  {
    sizes: ["120*130", "120*120", "110*110"],
    prices: { aluNoWood: 33000, aluWithWood: 45000, kasTekFiber: 63000, kasDoubleFiber: 85000, woodOnly: 12000 }
  },
  {
    sizes: ["130*130", "140*140"],
    prices: { aluNoWood: 33000, aluWithWood: 53000, kasTekFiber: 100000, kasDoubleFiber: 115000, woodOnly: 20000 }
  },
  {
    sizes: [ "150*150", "160*160"],
    prices: { aluNoWood: 38000, aluWithWood: 63000, kasTekFiber: 120000, kasDoubleFiber: 138000, woodOnly: 25000 }
  },
  {
    sizes: ["170*170", "180*180"],
    prices: { aluNoWood: 45000, aluWithWood: 70000, kasTekFiber: 125000, kasDoubleFiber: 165000, woodOnly: 30000 }
  },
  {
    sizes: ["190*190", "200*200"],
    prices: { aluNoWood: 47000, aluWithWood: 82000, kasTekFiber: 165000, kasDoubleFiber: 175000, woodOnly: 40000 }
  },
  {
    sizes: ["260*260", "270*270", "250*250"],
    prices: { aluNoWood: 65000, aluWithWood: 115000, kasTekFiber: 125000, kasDoubleFiber: 160000, woodOnly: 50000 }
  }
];



const TYPE_OPTIONS = [
  { key: "aluNoWood", label: "أل بدون خشب" },
  { key: "aluWithWood", label: "أل مع الخشب" },
  { key: "kasTekFiber", label: "كاس تك مع فايبر" },
  { key: "kasDoubleFiber", label: "كاس دبل مع فايبر" },
  { key: "woodOnly", label: "خشب فقط" },
];

const LS_KEY = "artika_frame_invoices_v1";

function formatIQD(n) {
  const num = Number(n || 0);
  return `${num.toLocaleString("en-US")} د.ع`;
}

function todayDate() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}
function generateInvoiceNumberForCustomer(customer, customers) {
  const year = new Date().getFullYear();
  const prefix = `AR${year}`;

  // فواتير هذا الزبون فقط
  const invoices = customer?.invoices || [];

  // نأخذ فقط أرقام هذه السنة
  const thisYear = invoices.filter(inv => inv.number?.startsWith(prefix));

  let max = 0;
  thisYear.forEach(inv => {
    const n = parseInt(inv.number.replace(prefix, ""), 10);
    if (!isNaN(n) && n > max) max = n;
  });

  const next = String(max + 1).padStart(4, "0");
  return `${prefix}${next}`;
}
function uid() {
  return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export default function FrameInvoiceSystem() {
  const [tab, setTab] = useState(0);

  // بيانات
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");

  // إنشاء فاتورة
const [saleMode] = useState("customer");
  const [invoiceRows, setInvoiceRows] = useState([]);
  const [invoiceNote, setInvoiceNote] = useState("");
const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(todayDate());

  // مودال زبون جديد
  const [addCustomerOpen, setAddCustomerOpen] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ name: "", phone: "", address: "" });

  // زبائني - عرض تفاصيل
  const [viewCustomerId, setViewCustomerId] = useState("");

  // تحميل من LocalStorage
  useEffect(() => {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed.customers)) setCustomers(parsed.customers);
      }
    } catch (e) {}
  }, []);

  // حفظ دائم
  useEffect(() => {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({ customers }));
    } catch (e) {}
  }, [customers]);

  const selectedCustomer = useMemo(
    () => customers.find((c) => c.id === selectedCustomerId) || null,
    [customers, selectedCustomerId]
  );
useEffect(() => {
  if (selectedCustomer) {
    setInvoiceNumber(generateInvoiceNumberForCustomer(selectedCustomer, customers));
  } else {
    setInvoiceNumber("");
  }
}, [selectedCustomerId, customers]); // مهم
  const viewCustomer = useMemo(
    () => customers.find((c) => c.id === viewCustomerId) || null,
    [customers, viewCustomerId]
  );


const printStatement = () => {
  if (!viewCustomer) return;

  let invoicesRows = "";
  let paymentsRows = "";

  // تفاصيل الفواتير
  (viewCustomer.invoices || []).forEach(inv => {
    inv.rows.forEach(row => {
      invoicesRows += `
        <tr>
          <td>${inv.number}</td>
          <td>${inv.date}</td>
          <td>${row.size || (row.customW + " × " + row.customH)}</td>
          <td>${TYPE_OPTIONS.find(t => t.key === row.type)?.label || ""}</td>
          <td>${row.qty}</td>
          <td>${Number(row.unitPrice).toLocaleString()}</td>
          <td>${Number(row.total).toLocaleString()}</td>
        </tr>
      `;
    });
  });

  // المدفوعات
  (viewCustomer.payments || []).forEach(p => {
  paymentsRows += `
  <tr>
    <td>${p.date}</td>
    <td>${Number(p.amount).toLocaleString("en-US")}</td>
    <td>${p.note ? p.note : "-"}</td>
  </tr>
`;
  });

  const totalInvoices = (viewCustomer.invoices || [])
    .reduce((sum, inv) => sum + Number(inv.total), 0);

  const totalPaid = (viewCustomer.payments || [])
    .reduce((sum, p) => sum + Number(p.amount), 0);

  const remaining = totalInvoices - totalPaid;

  const win = window.open("", "", "width=1000,height=800");

  win.document.write(`
    <html>
      <head>
        <title>كشف حساب ${viewCustomer.name}</title>
        <style>
          body {
            font-family: Arial;
            direction: rtl;
            padding: 40px;
          }
          h2 {
            text-align: center;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          th, td {
            border: 1px solid #000;
            padding: 6px;
            text-align: center;
            font-size: 14px;
          }
          .summary {
            margin-top: 20px;
            font-weight: bold;
            font-size: 16px;
          }
        </style>
      </head>
      <body>

        <h2>كشف حساب</h2>

        <p><strong>الزبون:</strong> ${viewCustomer.name}</p>
        <p><strong>الهاتف:</strong> ${viewCustomer.phone || "-"}</p>
        <hr/>

        <h3>الفواتير</h3>
        <table>
          <thead>
            <tr>
              <th>رقم الفاتورة</th>
              <th>التاريخ</th>
              <th>القياس</th>
              <th>النوع</th>
              <th>العدد</th>
              <th>سعر الوحدة</th>
              <th>المجموع</th>
            </tr>
          </thead>
          <tbody>
            ${invoicesRows}
          </tbody>
        </table>

        <h3>المدفوعات</h3>
        <table>
          <thead>
            <tr>
              <th>التاريخ</th>
              <th>المبلغ</th>
              <th>ملاحظات</th>
            </tr>
          </thead>
          <tbody>
            ${paymentsRows}
          </tbody>
        </table>

        <div class="summary">
          <p>إجمالي الفواتير: ${totalInvoices.toLocaleString()} د.ع</p>
          <p>إجمالي المدفوع: ${totalPaid.toLocaleString()} د.ع</p>
          <p>المتبقي: ${remaining.toLocaleString()} د.ع</p>
        </div>

      </body>
    </html>
  `);

  win.document.close();
  win.print();
};


  const addEmptyRow = () => {
    setInvoiceRows((prev) => [
      ...prev,
      {
        id: uid(),
        size: "",
        customW: "",
        customH: "",
        isCustom: false,
        type: "aluNoWood",
        qty: 1,
        notes: "",
        unitPrice: 0,
        total: 0,
      },
    ]);
  };

  useEffect(() => {
    // أول ما يفتح "إنشاء فاتورة" نخلي سطر واحد افتراضياً
    if (tab === 0 && invoiceRows.length === 0) addEmptyRow();
    // eslint-disable-next-line
  }, [tab]);

  const calcUnitPrice = (row) => {
  if (!row || row.isCustom || !row.size) return 0;

  const group = PRICE_GROUPS.find(g => g.sizes.includes(row.size));
  if (!group) return 0;

  return Number(group.prices[row.type] || 0);
};


  const recalcRow = (row) => {
    const unitPrice = row.isCustom ? Number(row.unitPrice || 0) : calcUnitPrice(row);
    const qty = Number(row.qty || 0);
    const total = unitPrice * qty;
    return { ...row, unitPrice, total };
  };

  const updateRow = (id, patch) => {
    setInvoiceRows((prev) =>
      prev.map((r) => {
        if (r.id !== id) return r;
        const merged = { ...r, ...patch };

        // إذا اختار "أخرى"
        if (patch.size === "__custom__") {
          merged.isCustom = true;
          merged.size = "";
          merged.unitPrice = merged.unitPrice || 0;
        }

        // إذا رجع يختار قياس جاهز
        if (patch.size && patch.size !== "__custom__") {
          merged.isCustom = false;
          merged.customW = "";
          merged.customH = "";
        }

        return recalcRow(merged);
      })
    );
  };

  const removeRow = (id) => {
    setInvoiceRows((prev) => prev.filter((r) => r.id !== id));
  };

  const invoiceTotal = useMemo(
    () => invoiceRows.reduce((sum, r) => sum + Number(r.total || 0), 0),
    [invoiceRows]
  );

  const currentBalance = useMemo(() => {
    if (!selectedCustomer) return 0;
    return Number(selectedCustomer.balance || 0);
  }, [selectedCustomer]);

  const canSaveInvoice = useMemo(() => {
if (!selectedCustomer) return false;
    // لازم يكون اكو على الأقل سطر واحد بمجموع > 0
    const hasValid = invoiceRows.some((r) => Number(r.total || 0) > 0);
    return hasValid;
  }, [saleMode, selectedCustomer, invoiceRows]);

 const resetInvoice = () => {
  setInvoiceRows([]);
  setInvoiceNote("");
  setInvoiceDate(todayDate());
  // لا نغيّر invoiceNumber هنا لأن هو يعتمد على الزبون المختار
};

  const saveInvoice = () => {
    if (!canSaveInvoice) {
resetInvoice();
alert("✅ تم حفظ الفاتورة بنجاح");      return;
    }

    const invoice = {
      id: uid(),
      number: invoiceNumber,
      date: invoiceDate,
      mode: saleMode, // customer/direct
      note: invoiceNote,
      rows: invoiceRows,
      total: invoiceTotal,
      createdAt: new Date().toISOString(),
    };

    if (saleMode === "customer") {
      // زبون عادي: تضاف الفاتورة ويزيد الرصيد
      setCustomers((prev) =>
        prev.map((c) =>
          c.id === selectedCustomer.id
            ? {
                ...c,
                balance: Number(c.balance || 0) + invoiceTotal,
                invoices: [...(c.invoices || []), invoice],
              }
            : c
        )
      );
    }

    resetInvoice();
if (selectedCustomer) {
  setInvoiceNumber(
    generateInvoiceNumberForCustomer(selectedCustomer, customers)
  );
}    alert("✅ تم حفظ الفاتورة بنجاح");
  };
// بعد الحفظ نولّد رقم جديد لنفس الزبون

  const openAddCustomer = () => {
    setNewCustomer({ name: "", phone: "", address: "" });
    setAddCustomerOpen(true);
  };

  const saveNewCustomer = () => {
    if (!newCustomer.name.trim()) return alert("اكتب اسم الزبون");
    if (!newCustomer.phone.trim()) return alert("اكتب رقم الهاتف");
    // رقم فقط
    if (!/^\d+$/.test(newCustomer.phone.trim())) return alert("رقم الهاتف لازم يكون أرقام فقط");

    const c = {
      id: uid(),
      name: newCustomer.name.trim(),
      phone: newCustomer.phone.trim(),
      address: newCustomer.address.trim(),
      balance: 0,
      invoices: [],
      payments: [],
    };

    setCustomers((prev) => [c, ...prev]);
    setSelectedCustomerId(c.id);
    setAddCustomerOpen(false);
  };

const [commissionOpen, setCommissionOpen] = useState(false);
const [commissionCustomerId, setCommissionCustomerId] = useState(null);
const [commissionAmount, setCommissionAmount] = useState("");
const [commissionNote, setCommissionNote] = useState(""); // ✅ ملاحظات التسديد

const payCommission = (customerId) => {
  setCommissionCustomerId(customerId);
  setCommissionAmount("");
    setCommissionNote(""); // ✅ تصفير الملاحظات
  setCommissionOpen(true);
};

const confirmCommission = () => {
  const amount = Number(commissionAmount.replace(/,/g, ""));
  if (!amount || amount <= 0) return;

  const note = (commissionNote || "").trim(); // ✅ ملاحظة اختيارية

  setCustomers((prev) =>
    prev.map((c) => {
      if (c.id !== commissionCustomerId) return c;

      return {
        ...c,
        balance: Math.max(0, Number(c.balance || 0) - amount),
       payments: [
  ...(c.payments || []),
  { id: uid(), amount, date: todayDate(), note: commissionNote.trim() },
],
      };
    })
  );

  setCommissionOpen(false);
};


  const pageTitle = "فاتورة  الإطارات";

  return (
    <Box dir="rtl" sx={{ maxWidth: 1200, mx: "auto" }}>
      {/* رأس الصفحة */}
      <Card sx={{ borderRadius: 3, mb: 2 }}>
        <CardContent>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
            <Stack spacing={0.5}>
              <Typography variant="h5" sx={{ fontWeight: 800 }}>
                {pageTitle}
              </Typography>
            
            </Stack>

          
          </Stack>

          <Divider sx={{ my: 2 }} />

          <Tabs value={tab} onChange={(e, v) => setTab(v)}>
            <Tab icon={<AddIcon />} iconPosition="start" label="إنشاء فاتورة جديدة" />
            <Tab icon={<PeopleIcon />} iconPosition="start" label="زبائني" />
          </Tabs>
        </CardContent>
      </Card>

      {/* تبويب إنشاء فاتورة */}
      {tab === 0 && (
        <Stack spacing={2}>
          {/* وضع البيع + بيانات الزبون */}
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
                بيانات الفاتورة
              </Typography>

              <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ mt: 1 }}>
              

                <TextField
                  fullWidth
                  label="تاريخ الفاتورة"
                  type="date"
                  value={invoiceDate}
                  onChange={(e) => setInvoiceDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />

             
              </Stack>

              {saleMode === "customer" && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">
                    <FormControl fullWidth>
                      <InputLabel>اختيار الزبون</InputLabel>
                      <Select
                        label="اختيار الزبون"
                        value={selectedCustomerId}
                        onChange={(e) => setSelectedCustomerId(e.target.value)}
                      >
                        <MenuItem value="">— اختر زبون —</MenuItem>
                        {customers
                          .filter((c) => c.id !== "DIRECT_SALES")
                          .map((c) => (
                            <MenuItem key={c.id} value={c.id}>
                              {c.name} — {formatIQD(c.balance || 0)}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>

                    <Button variant="contained" onClick={openAddCustomer} sx={{ minWidth: 180 }}>
                      ➕ إضافة زبون جديد
                    </Button>
                  </Stack>

                  {selectedCustomer && (
                    <Alert sx={{ mt: 2 }} severity="info">
                      <b>{selectedCustomer.name}</b> — هاتف: {selectedCustomer.phone || "-"} — عنوان:{" "}
                      {selectedCustomer.address || "—"}
                      <br />
                      الرصيد السابق: <b>{formatIQD(currentBalance)}</b>
                    </Alert>
                  )}
                </>
              )}
            </CardContent>
          </Card>

          {/* جدول السطور */}
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" sx={{ fontWeight: 800 }}>
                  تفاصيل الفاتورة
                </Typography>

                <Button variant="outlined" startIcon={<AddIcon />} onClick={addEmptyRow}>
                  إضافة سطر
                </Button>
              </Stack>

              <Box sx={{ mt: 2, overflowX: "auto" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 800 }}>القياس</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>النوع</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>العدد</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>سعر الوحدة</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>ملاحظات</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>المجموع</TableCell>
                      <TableCell sx={{ fontWeight: 800, textAlign: "center" }}>حذف</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {invoiceRows.map((r) => (
                      <TableRow key={r.id} hover>
                        {/* القياس */}
                        <TableCell sx={{ minWidth: 220 }}>
                          <Stack spacing={1}>
                            <FormControl fullWidth size="small">
                              <InputLabel>القياس</InputLabel>
                              <Select
                                label="القياس"
                                value={r.isCustom ? "__custom__" : (r.size || "")}
                                onChange={(e) => updateRow(r.id, { size: e.target.value })}
                              >
                                <MenuItem value="">— اختر قياس —</MenuItem>
                                {PRICE_GROUPS.flatMap(g => g.sizes).map
((s) => (
                                  <MenuItem key={s} value={s}>
                                    {s}
                                  </MenuItem>
                                ))}
                                <MenuItem value="__custom__">أخرى (إدخال يدوي)</MenuItem>
                              </Select>
                            </FormControl>

                            {r.isCustom && (
                              <Stack direction="row" spacing={1}>
                                <TextField
                                  size="small"
                                  label="الطول (cm)"
                                     type="number"
                                  value={r.customW}
                                  onChange={(e) => updateRow(r.id, { customW: e.target.value })}
                                  fullWidth
                                />
                                <TextField
                                  size="small"
                                  label="العرض (cm)"
                                     type="number"
                                  value={r.customH}
                                  onChange={(e) => updateRow(r.id, { customH: e.target.value })}
                                  fullWidth
                                />
                              </Stack>
                            )}
                          </Stack>
                        </TableCell>

                        {/* النوع */}
                        <TableCell sx={{ minWidth: 200 }}>
                          <FormControl fullWidth size="small">
                            <InputLabel>النوع</InputLabel>
                            <Select
                              label="النوع"
                              value={r.type}
                              onChange={(e) => updateRow(r.id, { type: e.target.value })}
                            >
                              {TYPE_OPTIONS.map((t) => (
                                <MenuItem key={t.key} value={t.key}>
                                  {t.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>

                        {/* العدد */}
                        <TableCell sx={{ minWidth: 120 }}>
                          <TextField
                            size="small"
                            type="number"
                            label="العدد"
                            value={r.qty}
                            onChange={(e) => updateRow(r.id, { qty: Number(e.target.value) })}
                            fullWidth
                          />
                        </TableCell>

                        {/* سعر الوحدة */}
                        <TableCell sx={{ minWidth: 160 }}>
                          <TextField
                            size="small"
                            type="number"
                            label="سعر الوحدة"
                            value={r.unitPrice}
                            onChange={(e) => updateRow(r.id, { unitPrice: Number(e.target.value), isCustom: true })}
                            helperText={r.isCustom ? "يدوي" : "تلقائي حسب القياس"}
                            fullWidth
                          />
                        </TableCell>

                        {/* ملاحظات */}
                        <TableCell sx={{ minWidth: 220 }}>
                          <TextField
                            size="small"
                            label="ملاحظات"
                            value={r.notes}
                            onChange={(e) => updateRow(r.id, { notes: e.target.value })}
                            fullWidth
                          />
                        </TableCell>

                        {/* المجموع */}
                        <TableCell sx={{ minWidth: 160 }}>
                          <Typography sx={{ fontWeight: 800 }}>{formatIQD(r.total)}</Typography>
                        </TableCell>

                        {/* حذف */}
                        <TableCell sx={{ textAlign: "center" }}>
                          <Tooltip title="حذف السطر">
                            <IconButton color="error" onClick={() => removeRow(r.id)}>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems="center" spacing={2}>
                <Stack spacing={0.5}>
                  <Typography variant="body2" color="text.secondary">
                    المجموع الكلي
                  </Typography>
                  <Typography variant="h5" sx={{ fontWeight: 900 }}>
                    {formatIQD(invoiceTotal)}
                  </Typography>
                </Stack>

                <Stack direction="row" spacing={1}>
                  <Button variant="outlined" onClick={resetInvoice}>
                    مسح الفاتورة
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    disabled={!canSaveInvoice}
                    onClick={saveInvoice}
                  >
                    حفظ الفاتورة
                  </Button>
                </Stack>
              </Stack>

              {saleMode === "customer" && selectedCustomer && (
                <Box sx={{ mt: 2 }}>
                  <Alert severity="success">
                    الرصيد بعد الحفظ (تقريباً): <b>{formatIQD(currentBalance + invoiceTotal)}</b>
                  </Alert>
                </Box>
              )}
            </CardContent>
          </Card>
        </Stack>
      )}

      {/* تبويب زبائني */}
      {tab === 1 && (
        <Stack spacing={2}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
                زبائني
              </Typography>

             

              <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">
                <FormControl fullWidth>
                  <InputLabel>اختيار زبون للعرض</InputLabel>
                  <Select
                    label="اختيار زبون للعرض"
                    value={viewCustomerId}
                    onChange={(e) => setViewCustomerId(e.target.value)}
                  >
                    <MenuItem value="">— اختر —</MenuItem>
                    {customers.map((c) => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.name} — {formatIQD(c.balance || 0)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button variant="contained" onClick={openAddCustomer} sx={{ minWidth: 180 }}>
                  ➕ إضافة زبون جديد
                </Button>
              </Stack>

              <Divider sx={{ my: 2 }} />

              {/* قائمة سريعة */}
              <Box sx={{ overflowX: "auto" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 800 }}>الزبون</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>الهاتف</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>الرصيد</TableCell>
                      <TableCell sx={{ fontWeight: 800 }}>عدد الفواتير</TableCell>
                      <TableCell sx={{ fontWeight: 800, textAlign: "center" }}>إجراءات</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customers.map((c) => (
                      <TableRow key={c.id} hover>
                        <TableCell sx={{ fontWeight: 800 }}>{c.name}</TableCell>
                        <TableCell>{c.phone || "-"}</TableCell>
                        <TableCell>
                          <Chip label={formatIQD(c.balance || 0)} color={(c.balance || 0) > 0 ? "warning" : "default"} />
                        </TableCell>
                        <TableCell>{(c.invoices || []).length}</TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <Stack direction="row" spacing={1} justifyContent="center">
                            <Button variant="outlined" onClick={() => setViewCustomerId(c.id)}>
                              عرض
                            </Button>
                            <Button
                              variant="contained"
                              startIcon={<PaidIcon />}
                              onClick={() => payCommission(c.id)}
                              disabled={Number(c.balance || 0) <= 0}
                            >
تسديد                            </Button>
<Button
  variant="contained"
  color="error"
  onClick={() => {
    if (window.confirm(`حذف الزبون ${c.name} وكل فواتيره؟`)) {
      setCustomers(prev => prev.filter(x => x.id !== c.id));
      if (viewCustomerId === c.id) setViewCustomerId("");
      if (selectedCustomerId === c.id) setSelectedCustomerId("");
    }
  }}
>
  حذف
</Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

        {/* تفاصيل زبون بشكل ورقة (مثل الطباعة) */}
{viewCustomer && (() => {
  const invoices = [...(viewCustomer.invoices || [])].reverse();
  const payments = [...(viewCustomer.payments || [])].reverse();

  const totalInvoices = (viewCustomer.invoices || []).reduce((sum, inv) => sum + Number(inv.total || 0), 0);
  const totalPaid = (viewCustomer.payments || []).reduce((sum, p) => sum + Number(p.amount || 0), 0);
  const remaining = totalInvoices - totalPaid;

  return (
    <Box sx={{ mt: 3 }}>
      <Divider sx={{ mb: 2 }} />

      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>
          كشف حساب
        </Typography>

        <Button variant="contained" onClick={() => printStatement()}>
          طباعة كشف الحساب
        </Button>
      </Stack>

      {/* ورقة العرض */}
      <Box
        sx={{
          bgcolor: "#fff",
          border: "1px solid #ddd",
          borderRadius: 2,
          p: 3,
          maxWidth: 900,
          mx: "auto",
        }}
      >
        <Typography sx={{ textAlign: "center", fontSize: 26, fontWeight: 900, mb: 2 }}>
          كشف حساب
        </Typography>

        <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
          <Box>
            <Typography sx={{ fontWeight: 800 }}>الزبون: {viewCustomer.name}</Typography>
            <Typography sx={{ color: "text.secondary" }}>الهاتف: {viewCustomer.phone || "-"}</Typography>
            <Typography sx={{ color: "text.secondary" }}>العنوان: {viewCustomer.address || "—"}</Typography>
          </Box>

          <Box sx={{ textAlign: "left" }}>
            <Typography sx={{ color: "text.secondary" }}>
              التاريخ: {todayDate()}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* جدول الفواتير */}
        <Typography sx={{ fontWeight: 900, mb: 1 }}>الفواتير</Typography>

        <Box sx={{ overflowX: "auto" }}>
          <Table size="small" sx={{ border: "1px solid #000" }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>رقم الفاتورة</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>التاريخ</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>القياس</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>النوع</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>العدد</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>سعر الوحدة</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>المجموع</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {invoices.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: "center", border: "1px solid #000" }}>
                    لا توجد فواتير
                  </TableCell>
                </TableRow>
              ) : (
                invoices.flatMap((inv) =>
                  (inv.rows || []).map((row, idx) => {
                    const sizeText = row.size ? row.size : `${row.customW || ""}×${row.customH || ""}`;
                    const typeLabel = TYPE_OPTIONS.find((t) => t.key === row.type)?.label || "";
                    return (
                      <TableRow key={`${inv.id}_${idx}`}>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: 800 }}>{inv.number}</TableCell>
                        <TableCell sx={{ border: "1px solid #000" }}>{inv.date}</TableCell>
                        <TableCell sx={{ border: "1px solid #000" }}>{sizeText}</TableCell>
                        <TableCell sx={{ border: "1px solid #000" }}>{typeLabel}</TableCell>
                        <TableCell sx={{ border: "1px solid #000" }}>{row.qty}</TableCell>
                        <TableCell sx={{ border: "1px solid #000" }}>{Number(row.unitPrice || 0).toLocaleString("en-US")}</TableCell>
                        <TableCell sx={{ border: "1px solid #000", fontWeight: 900 }}>{Number(row.total || 0).toLocaleString("en-US")}</TableCell>
                      </TableRow>
                    );
                  })
                )
              )}
            </TableBody>
          </Table>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* جدول المدفوعات */}
        <Typography sx={{ fontWeight: 900, mb: 1 }}>المدفوعات</Typography>

        <Box sx={{ overflowX: "auto" }}>
          <Table size="small" sx={{ border: "1px solid #000" }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>التاريخ</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>المبلغ</TableCell>
                <TableCell sx={{ fontWeight: 900, border: "1px solid #000" }}>ملاحظات</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payments.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} sx={{ textAlign: "center", border: "1px solid #000" }}>
                    لا توجد مدفوعات
                  </TableCell>
                </TableRow>
              ) : (
                payments.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell sx={{ border: "1px solid #000" }}>{p.date}</TableCell>
                    <TableCell sx={{ border: "1px solid #000", fontWeight: 900 }}>
                      {Number(p.amount || 0).toLocaleString("en-US")}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid #000" }}>{p.note || "—"}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* الملخص */}
        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontWeight: 900 }}>
            إجمالي الفواتير: {totalInvoices.toLocaleString("en-US")} د.ع
          </Typography>
          <Typography sx={{ fontWeight: 900 }}>
            إجمالي المدفوع: {totalPaid.toLocaleString("en-US")} د.ع
          </Typography>
          <Typography sx={{ fontWeight: 900 }}>
            المتبقي: {remaining.toLocaleString("en-US")} د.ع
          </Typography>
        </Box>
      </Box>
    </Box>
  );
})()}
            </CardContent>
          </Card>
        </Stack>
      )}

      {/* مودال إضافة زبون */}
      <Dialog open={addCustomerOpen} onClose={() => setAddCustomerOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 900 }}>إضافة زبون جديد</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              label="اسم الزبون"
              value={newCustomer.name}
              onChange={(e) => setNewCustomer((p) => ({ ...p, name: e.target.value }))}
              fullWidth
            />
            <TextField
              label="رقم الهاتف (أرقام فقط)"
              value={newCustomer.phone}
              onChange={(e) => setNewCustomer((p) => ({ ...p, phone: e.target.value.replace(/[^\d]/g, "") }))}
              fullWidth
            />
            <TextField
              label="العنوان (اختياري)"
              value={newCustomer.address}
              onChange={(e) => setNewCustomer((p) => ({ ...p, address: e.target.value }))}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddCustomerOpen(false)}>إلغاء</Button>
          <Button variant="contained" onClick={saveNewCustomer}>
            حفظ
          </Button>
        </DialogActions>
      </Dialog>

      {/* تنبيه مصدر الأسعار */}
     <Dialog open={commissionOpen} onClose={() => setCommissionOpen(false)}>
  <DialogTitle>تسديد </DialogTitle>
  <DialogContent>
  <TextField
  label="المبلغ"
  value={commissionAmount}
  onChange={(e) => {
    const raw = e.target.value.replace(/[^\d]/g, "");
    const formatted = raw
      ? Number(raw).toLocaleString("en-US")
      : "";
    setCommissionAmount(formatted);
  }}
  fullWidth
/>
 <TextField
        label="ملاحظات (اختياري)"
        value={commissionNote}
        onChange={(e) => setCommissionNote(e.target.value)}
        fullWidth
        multiline
        minRows={2}
      />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setCommissionOpen(false)}>إلغاء</Button>
    <Button variant="contained" onClick={confirmCommission}>
      تأكيد
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
}
